module.exports = __webpack_public_path__ + "static/media/about_us_picture_small.4827ba50.jpg";